// extracted by mini-css-extract-plugin
export default {"sideNavbar":"SideNavbar_sideNavbar__s6TMh","searchInput":"SideNavbar_searchInput__RG2vW","navbarList":"SideNavbar_navbarList__U-fR9"};